import React, { useContext, useEffect, useState, Suspense } from 'react'
import './Tailwind.css'
import { getCompanyInfoHelper } from './helpers/getCompanyInfoHelper'
import { DataContext } from './context/DataContext'
import { CheckoutSkeleton, Spinner } from '@pinflag/pinflag-ui-kit'

const MagentoProviderLazy = React.lazy(() => import('./context/MagentoContext').then(module => ({ default: module.MagentoProvider })))
const PinmapProLazy = React.lazy(() => import('./PinmapPro'))

const App = () => {
  const { setUserInfo, setCompanyInfo, isPickup } = useContext(DataContext)
  const [app, setApp] = useState(<CheckoutSkeleton isPickup={isPickup} />)
  const isLoaderIframe = new URLSearchParams(document.location.search).get('loaderIframe')
  const SpinnerComponent = <div className='full_width_spinner'>
    <Spinner/>
  </div>

  useEffect(() => {
    window.addEventListener('message', receiveMessage)
    getCompanyInfoHelper(setUserInfo, setCompanyInfo)
    return () => {
      window.removeEventListener('message', receiveMessage)
    }
  }, [])

  useEffect(() => {
    if (isLoaderIframe) {
      setApp(
        <Suspense fallback={SpinnerComponent}>
          <MagentoProviderLazy>
            <PinmapProLazy/>
          </MagentoProviderLazy>
        </Suspense>
      )
      window.removeEventListener('message', receiveMessage)
    }
  }, [isLoaderIframe])

  const receiveMessage = async (event) => {
    if (event?.data?.type) {
      const { message, origin, type } = event.data
      if (type === 'receive-cart-info') {
        const pinmap = import('./PinmapPro')
        const magento = import('./context/MagentoContext')
        const [{ default: PinmapPro }, { MagentoProvider }] = await Promise.all([pinmap, magento])
        setApp(
          <MagentoProvider>
            <PinmapPro cartMessage={message} cartOrigin={origin} />
          </MagentoProvider>
        )
        window.removeEventListener('message', receiveMessage)
      } else if (type === 'is-ready') {
        getCompanyInfoHelper(setUserInfo, setCompanyInfo)
      }
    }
  }

  return app
}

export default App
